import React from 'react'
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const ThoughtLeadership = () => {
	const allPagesContent = useSelector((state) => state.pages.pages)
    const tLeadershipContent = allPagesContent.find((page) => page.slug === 'thought-leadership')
	const isPageLoading = useSelector((state) => state.pages.isLoading)
	return (
		isPageLoading ?
			<div className='spinner-wrapper'> 
				<Spinner animation="border" variant="info" />
			</div>
		:
		<div className='main-text-section'>
			<Container>
				<Row>
					<Col>
						<h2>Thought Leadership</h2>
						<div dangerouslySetInnerHTML={{ __html: tLeadershipContent?.content?.rendered }}></div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

export default ThoughtLeadership